import React from 'react'

import { View } from 'lib/components'

export default function PrintHR() {
  return <View width="100%" borderBottom="solid 1px #a2a2a2" my={2} />
}
